import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/vineyardStyles'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'vineyardStyles'

export const metadata = {
  icon: 'vine',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const VineyardStylesListPage = createListPage({ metadata, api, actionCreators, Content })
const VineyardStylesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { VineyardStylesListPage, VineyardStylesDetailPage }
